var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoleto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    fillRule: "evenodd",
    d: "M52.43 25.56c0 2-2 3.65-4.37 3.65H4.37c-2.4 0-4.37-1.64-4.37-3.65V3.65C0 1.65 2 0 4.37 0h43.69c2.4 0 4.37 1.64 4.37 3.65v21.91z",
    className: "boleto_svg__cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "M48.06 0H4.37C1.97 0 0 1.64 0 3.65v21.91c0 2 2 3.65 4.37 3.65h43.69c2.4 0 4.37-1.64 4.37-3.65V3.65c0-2.01-1.97-3.65-4.37-3.65zm0 .73a3.25 3.25 0 013.5 2.92v21.91a3.25 3.25 0 01-3.5 2.92H4.37a3.24 3.24 0 01-3.49-2.92V3.65A3.24 3.24 0 014.37.73h43.69z",
    className: "boleto_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.09 7.25h1.73v14.69h-1.73V7.25zm10.62 0h1.73v14.69h-1.73V7.25zm8.84 0h1.73v14.69h-1.73V7.25zm3.51 0h1.71v14.69h-1.73l.02-14.69zm3.56 0h1.72v14.69h-1.72V7.25zm-12.39 0h3.54v14.69h-3.54V7.25zm-10.61 0h5.29v14.69h-5.29V7.25z",
    className: "boleto_svg__cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff4027",
    fillRule: "evenodd",
    d: "M7.43 15.37h37.58v2.19H7.43v-2.19z",
    className: "boleto_svg__cls-11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoleto);
export default __webpack_public_path__ + "static/media/boleto.0889452b18edd5e646bccadf811f9f6a.svg";
export { ForwardRef as ReactComponent };